import {
    AccessGroupSchema,
    AccountSchema,
    AccountStatisticsSchema,
    ContactSchema,
    ContactTypeSchema,
    ControlSchema,
    ControlTypeSchema,
    DefaultTaskSchema,
    ExternalLookupProviderSchema,
    ExternalLookupSchema,
    FieldSchema,
    FileSchema,
    FormSchema,
    GroupSchema,
    JobSchema,
    JobStatusSchema,
    JobTypeSchema,
    LookupSchema,
    LookupTypeSchema,
    MembershipSchema,
    NoteSchema,
    NotificationTemplateSchema,
    ReportLayoutSchema,
    ReportSchema, TaskSchema, TaskTypeSchema, TransitionSchema, UserSchema
} from '../vas/api/schema';
import { CategoryGroupSchema } from '../vas/business-objects/category-group/category-group.schema';

export const SCHEMA_MAP = {
    accessGroup: AccessGroupSchema,
    account: AccountSchema,
    accountStatistics: AccountStatisticsSchema,
    categoryGroup: CategoryGroupSchema,
    contact: ContactSchema,
    contactType: ContactTypeSchema,
    control: ControlSchema,
    controlType: ControlTypeSchema,
    defaultTask: DefaultTaskSchema,
    externalLookup: ExternalLookupSchema,
    externalLookupProvider: ExternalLookupProviderSchema,
    field: FieldSchema,
    file: FileSchema,
    form: FormSchema,
    group: GroupSchema,
    job: JobSchema,
    jobStatus: JobStatusSchema,
    jobType: JobTypeSchema,
    lookup: LookupSchema,
    lookupType: LookupTypeSchema,
    membership: MembershipSchema,
    note: NoteSchema,
    notificationTemplate: NotificationTemplateSchema,
    report: ReportSchema,
    reportLayout: ReportLayoutSchema,
    task: TaskSchema,
    taskType: TaskTypeSchema,
    transition: TransitionSchema,
    user: UserSchema
}



// WEBPACK FOOTER //
// ./src/app/app.config.schema-map.ts